import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-skip-to-content', 'linkLabel', 'Skip to main content');
